import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from '@xstyled/styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const UserInputArea = styled.div`
z-index:1;
position: relative;
overflow: hidden;
margin-top: clamp(2px, 1vw, 10px);
margin-bottom: clamp(2px, 1vw, 10px);
margin-left: 0px;
margin-right: auto;
flex-shrink: 0;
width: clamp(95%, 1vw, 80%);
max-width: 900px;
margin-bottom: 2px;
border-radius: clamp(0px, 1vw, 10px);
border: 1px solid #aaa;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: #FFF;

textarea {
    padding: clamp(1px, 1vw, 10px);
    font-size: clamp(9px, 2vw, 12px);
    border: 1px solid #ccc0;
    background-color: #fff;
    width: 100%; 
    max-width: 880px; /* Optional max width */
    box-sizing: border-box; 
    resize: none;
    }
    `;

const UserInputHeader = styled.div`
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: space-between;
    align-items: center; /* Correct alignment for icons */
    padding: 2px clamp(1px, 1vw, 10px);
    cursor: pointer;
    background-color: #eee;
    color: #888;
    font-size: clamp(9px, 2vw, 14px);
    width: 100%; /* Matches the parent width */
    box-sizing: border-box;
    border-bottom: 1px solid #aaa; /* To clearly separate header from content */
    flex-direction: row;

    strong {
        margin: 0px;
        font-size: clamp(8px, 2vw, 14px);
    }
    span {
        font-size: clamp(9px, 2vw, 14px);
        font-weight: bold;
        display: flex;
        align-self: center;
    }
`;

const UserInputContainer = ({ setUserInput, userInput }) => {
    const textareaRef = useRef(null);
    const [isUserInputOpen, setIsUserInputOpen] = useState(true);

    const adjustTextAreaHeight = useCallback(() => {
        try {
            const textarea = textareaRef.current;
            if (!textarea) return;
            textarea.style.height = '20px';
            const newHeight = textarea.scrollHeight;
            const maxHeight = window.innerHeight * 0.3;
            textarea.style.height = `${Math.min(newHeight, maxHeight) + 5}px`;
        } catch (e) {
            //console.error('Error adjusting text area height:', e);
        }
    }, []);

    useEffect(() => {
        adjustTextAreaHeight();
    }, [userInput, adjustTextAreaHeight]);

    useEffect(() => {
        window.addEventListener('resize', adjustTextAreaHeight);
        return () => {
            window.removeEventListener('resize', adjustTextAreaHeight);
        };
    }, [adjustTextAreaHeight]);

    const handleTextAreaChange = (e) => {
        setUserInput(e.target.value);
        adjustTextAreaHeight();
    };


    const toggleUserInput = () => {
        setIsUserInputOpen(!isUserInputOpen);
        if (!isUserInputOpen) {
            setTimeout(adjustTextAreaHeight, 0);
        }
    };

    return (
        <UserInputArea>
            <UserInputHeader data-testid="user-input-header" onClick={toggleUserInput}>
                {isUserInputOpen && (<strong></strong>)}
                {!isUserInputOpen && (<strong>User Input</strong>)}
                <span>
                    <FontAwesomeIcon icon={isUserInputOpen ? faChevronDown : faChevronRight} />
                </span>
            </UserInputHeader>
            {isUserInputOpen && (
                <textarea
                    data-testid="user-input-container"
                    ref={textareaRef}
                    value={userInput}
                    onChange={handleTextAreaChange}
                    placeholder="Enter your situation here..."
                />
            )}
        </UserInputArea>
    );
};

export default UserInputContainer;
